import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import { SmartNav } from 'src/components/shared/SmartNav';
import { UtilityCredentialItem } from 'src/components/shared/UtilityCredentialItem';
import useBillingCredentialManagementStyles from './styles';
export const BillingCredentialManagementPage = observer(() => {
  const classes = useBillingCredentialManagementStyles();
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const fetchData = async () => {
    setIsLoading(true);

    // TODO: fetch data

    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.containerNav
  }, /*#__PURE__*/React.createElement(SmartNav, {
    isIcon: true,
    icon: 'building-empty',
    name: "Properties",
    title: "8510 North Halifax St.Oxnard, CA 93030",
    isPropertiesNav: true,
    isFullPage: true,
    selectAllLabel: 'All properties'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerBody
  }, [{
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com'
    // questions: [
    //   { questionName: 'What was your favourite school teacher’s name?', answerName: 'Blabla1' },
    //   { questionName: 'What was your favourite school teacher’s name? 2', answerName: 'blablah2' },
    // ],
  }, {
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name? ',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }, {
    id: '1231wqeq',
    username: 'TestU1',
    password: '123456',
    website: 'https://google.com',
    questions: [{
      questionName: 'What was your favourite school teacher’s name?',
      answerName: 'Blabla1'
    }, {
      questionName: 'What was your favourite school teacher’s name? 2',
      answerName: 'blablah2'
    }]
  }].map((utilityCredential, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container,
      id: 'utilityCredentialItemContainer'
    }, /*#__PURE__*/React.createElement(Typography, {
      className: "".concat(classes.smSection, " ").concat(classes.utilityCredentialItemTitle),
      variant: "h3"
    }, t('Electricity: San Jose Electricity Company')), /*#__PURE__*/React.createElement(UtilityCredentialItem, {
      credentialData: utilityCredential,
      key: 'UtilityCredentialItem_' + utilityCredential.id + index
    }));
  })));
});